import styled from 'styled-components';

export const StyledStatisticsCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;

  .Polaris-ShadowBevel {
    width: 100%;
  }

  .statistics-row {
    display: flex;
    align-items: center;
    gap: 1rem;
    width: 100%;

    .statistics-content {
      display: flex;
      flex-direction: row;
      gap: 0.5rem;
    }
  }
`;
